export { Devices, DeviceData } from './common'
export * from './models/deviceState'
export {
  TDevice,
  TDeviceCfg,
  TMessageSigfoxOut,
  TSensorSetting,
} from './entities/ric003'
export { processMessages, processMessagesForSingleDevice } from './processors'
export { convertToDeviceData } from './processors/utils'
export { loadDevices } from './processors/devices'
export { parseMessage } from './decoders'
export { SigFoxMessageType } from './common/constants'
export { getUniqueDevices } from './common/utils'

export { DeviceMode } from './common/enums'

// Testing (requires .env)
// export { runner } from './runner'
// import { runner } from './runner'
// runner()

export function helloWorld() {
  console.log('Hello World! -- from sigfox decoder')
}
